import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Paper, Skeleton, Typography } from "@mui/material";
import { PROFILE } from "@/graphql/queries/profile";
import { useMutation, useQuery } from "@apollo/client";
import { useMemo } from "react";
import { WARNING_RESOLVE } from "@/graphql/mutations/financial";
import { errorToast, successToast } from "@/utils/toasts";
import { useRouter } from "next/router";
import { LESSON } from "@/graphql/queries/lessons";
import TitlePayment, { PreTitlePayment } from "./TitlePayment";

export default function CreditPayment({ preTitle, charge, handleClose }) {
    const router = useRouter();

    const { data: { profile } = {}, loading: profileLoading } = useQuery(
        PROFILE,
        {
            fetchPolicy: "cache-first",
        }
    );

    const isAbleToPay = useMemo(
        () =>
            (function (balance, charge) {
                balance = Number(balance);
                charge = Number(charge);
                if (balance == 0 || charge == 0) return false;
                return balance >= charge;
            })(profile?.balance, charge),
        [profile?.balance, charge]
    );

    const [warningResolve, { loading: warningResolveLoading }] = useMutation(
        WARNING_RESOLVE,
        { refetchQueries: [LESSON, "lesson", PROFILE, "profile"] }
    );

    const onSubmit = () => {
        warningResolve({
            onCompleted: () => {
                successToast("پرداخت با موفقیت انجام شد ");
                typeof handleClose === "function" && handleClose();
            },
            onError: (error) => {
                errorToast(error?.message);
                typeof handleClose === "function" && handleClose();
            },
        });
    };

    return (
        <Paper variant="outlined">
            <Grid
                container
                rowSpacing={1}
                sx={{ padding: { xs: "10px", md: "20px" } }}
            >
                <Grid item xs={12}>
                    {preTitle && <PreTitlePayment>{preTitle}</PreTitlePayment>}
                    <TitlePayment>پرداخت از اعتبار</TitlePayment>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: "0.9rem" }}>
                        در صورتی که حساب شما اعتبار کافی داشته باشد می توانید از
                        اعتبار حساب خود پرداخت نمایید.
                    </Typography>
                </Grid>
                <Grid container xs={12} display="flex" alignItems="center">
                    <Grid xs={12} sm={8}>
                        {profileLoading && <Skeleton />}{" "}
                        {!profileLoading && isAbleToPay && (
                            <Typography
                                sx={{
                                    color: "green !important",
                                    fontSize: "0.9rem",
                                }}
                            >
                                اعتبار شما برای پرداخت کافی می باشد
                            </Typography>
                        )}
                        {!profileLoading && !isAbleToPay && (
                            <Typography
                                sx={{ color: "red", fontSize: "0.9rem" }}
                            >
                                اعتبار شما برای پرداخت کافی نمی باشد
                            </Typography>
                        )}
                    </Grid>
                    <Grid xs={12} sm={4}>
                        {isAbleToPay && (
                            <Button
                                onClick={() => onSubmit()}
                                disabled={
                                    profileLoading || warningResolveLoading
                                }
                                variant="contained"
                                size="small"
                                fullWidth
                            >
                                پرداخت از اعتبار
                            </Button>
                        )}

                        {!isAbleToPay && (
                            <Button
                                onClick={() => router.push("/financial/credit")}
                                disabled={
                                    profileLoading || warningResolveLoading
                                }
                                variant="contained"
                                size="small"
                                sx={{ whiteSpace: "nowrap" }}
                                fullWidth
                            >
                                افزایش اعتبار
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}
